import { AppService } from '../../app.service';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { UtilityFunctions } from '../../shared/utility-functions';

export class FacilityValidation {
    public validate;

    constructor(private appService: AppService, private utilityFunctions : UtilityFunctions) {
        this.validate = {
            validName: '',
            validNoOfUnits: '',
            validSlotDuration: '',
            validCategory: '',
            validOpenTime: '',
            validCloseTime: '',
            validBreakStart: '',
            validBreakStop: '',
            validUnitName: '',
            validIcon: '',
            validAmount: '',
            validHoldBooking: '',
            validMaxNumberOfPeopleWeekday: '',
            validMaxNumberOfPeopleWeekend: '',
            validMaxWeekdayBooking: '',
            validMaxWeekendBooking: '',
            validMaxBookingHoursWeekday: '',
            validmaxBookingHoursWeekend: '',
            validWaitlistCount: '',
            validPeekTime: '',
            validReminder: '',
            validNotificationAcceptanceHour: '',
            validPeekSlotDuraion: '',
            validUnitNames: '',
            flag: true,
            validClosedTime: '',
        };
    }
    validateNamePara(that, validPara, obj, facilityPara) {
        if (obj) {
            if(facilityPara == 'name'){
                if (!this.utilityFunctions.validateFacilityName(that[obj][facilityPara]) || that[obj][facilityPara] == '') {
                this.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            } else {
                this.validate[validPara] = '';
            }
            } else{
                if (!this.utilityFunctions.validateFacilityName(that[obj][facilityPara]) || that[obj][facilityPara] == '') {
                this.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            } else {
                this.validate[validPara] = '';
            }
            }
        }
        else {
            if (!this.utilityFunctions.validatenameString(that[facilityPara]) || that[facilityPara] == '') {
                this.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            } else {
                this.validate[validPara] = '';
            }
        }
    }

    validateParaForNUll(that, validPara, obj, facilityPara) {
        let thatFacilityValidation = this;
        if (obj) {
            setTimeout(function () {
                if (that[obj][facilityPara] === '') {
                    thatFacilityValidation.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                } else {
                    thatFacilityValidation.validate[validPara] = '';
                }
            }, 1000);
        } else {
            setTimeout(function () {
                if (that[facilityPara] === '') {
                    thatFacilityValidation.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                } else {
                    thatFacilityValidation.validate[validPara] = '';
                }
            }, 1000);
        }
    }

    validateTimeArray(that, flagToCheck, timeArray, validatePara) {
        let thatFacilityValidation = this;
        setTimeout(function () {
            if (!that.facility[flagToCheck]) {
                that[timeArray] = [];
            }
            if (that[timeArray].length <= 0 && that.facility[flagToCheck]) {
                thatFacilityValidation.validate[validatePara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            } else {
                thatFacilityValidation.validate[validatePara] = '';
            }
        }, 0);
    }

    setLocalValuestoFacility(that, iconObj) {
        that.facility.timings.openTime = (that.openTime) ? that.openTime + ':00:00' : '';
        that.facility.timings.closeTime = (that.closeTime) ? that.closeTime + ':00:00' : '';
        // when super admin create activity for specific condo
        if (that.vendor) {
            if (that.vendor.subVendors.length > 0) {
                let subvendor = that.vendor.subVendors[0];
                that.facility.vendorId = subvendor._id;
            }
        }
        that.facility.isAttendeeCountRequired = that.isAttendeeCountRequired;
        that.facility.isWaitlistEnabled = that.isWaitlistEnabled;
        that.facility.isChargable = that.isChargable;
        that.facility.isPeakTimeEnabled = that.isPeakTimeEnabled;
        that.facility.isBreakTimeEnabled = that.isBreakTimeEnabled;
        that.facility.isHoldBooking = that.facility.isChargable;
        that.facility.isMaxBookingPerMembership = that.isMaxBookingPerMembership;
        that.facility.isMaxBookingPerPerson = that.isMaxBookingPerPerson;
        if (iconObj && iconObj.name) {
            that.viewIcon.name = iconObj.name;
            that.viewIcon.iconClass = iconObj.iconClass;
            that.facility.icon = iconObj.name;
        }
    }

    changedRuleForAminity(that) {
        if (that.facility.category.indexOf(CONSTANT_VALUES.AMENITIES_CATEGORY) >= 0) {
            that.facility.maxBookingHoursWeekday = '';
            that.facility.maxBookingHoursWeekend = '';
            that.facility.isMaxBookingPerPerson = false;
            that.facility.maxWeekdayBooking = '';
            that.facility.maxWeekendBooking = '';
            if (that.facility.isMaxBookingPerMembership) {
                that.facility.maxBookingHoursMonth = '4';
            } else {
                that.facility.maxBookingHoursMonth = ''
            }
        }
    }

    setProperValuesToFacilityObj(that) {
        let timeObject = {};
        let unit;
        that.facility.unitNames = [];
        that.unitNames = that.unitNames.trim();
        that.facility.name = that.facility.name.trim();
        that.popUp = false;
        for (let i = 1; i <= parseInt(that.facility.noOfUnits); i++) {
            unit = that.unitNames + '-' + i;
            that.facility.unitNames.push(unit);
        }
        that.facility.breakTimings = [];
        that.facility.peekTimings = [];
        for (let item of that.closeTimeArray) {
            timeObject['start'] = item.start + ':00:00';
            timeObject['end'] = item.end + ':00:00';
            that.facility.breakTimings.push(timeObject);
            timeObject = {};
        }
        for (let item of that.peekTimingsArray) {
            timeObject['start'] = item.start + ':00:00';
            timeObject['end'] = item.end + ':00:00';
            that.facility.peekTimings.push(timeObject);
            timeObject = {};
        }
        if (that.facility.isChargable === false) {
            that.facility.amount.value = '';
            that.facility.holdBookingDays = '';
        }
        if (that.facility.isMaxBookingPerMembership === false) {
            that.facility.maxBookingHoursWeekday = '';
            that.facility.maxBookingHoursWeekend = '';
            that.facility.maxBookingHoursMonth = '';
        }
        if (that.facility.isMaxBookingPerPerson === false) {
            that.facility.maxWeekdayBooking = '';
            that.facility.maxWeekendBooking = '';
        }
        if (that.facility.isWaitlistEnabled === false) {
            that.facility.waitlistCount = '';
        }
        if (that.facility.isPeakTimeEnabled === false) {
            that.facility.peekTimings = [];
        }
        if (that.facility.isBreakTimeEnabled === false) {
            that.facility.breakTimings = [];
        }
        // that.setUTCTime();
        if (that.facility.category === CONSTANT_VALUES.AMENITIES_CATEGORY  || that.facility.category === CONSTANT_VALUES.TRAINER_CATEGORY || that.facility.category === CONSTANT_VALUES.PERSONALTRAINER_CATEGORY) {
            that.facility.slotDuration = '0';
        }
        if (!that.facility.isPeakTimeEnabled) {
            that.facility.peakUnitsCount = '0';
        }
        this.changedRuleForAminity(that);
    }

    validateFacilityTimings(that, validateField, iconObj) {
        this.setLocalValuestoFacility(that, iconObj);
        switch (validateField) {
            case 'openTime':
                this.validateParaForNUll(that, 'validOpenTime', '', 'openTime');
                break;
            case 'closeTime':
                this.validateParaForNUll(that, 'validCloseTime', '', 'closeTime');
                break;
            case 'facility.peakTime':
                this.validateTimeArray(that, 'isPeakTimeEnabled', 'peekTimingsArray', 'validPeekTime');
                break;
            case 'closedTime':
                this.validateTimeArray(that, 'isBreakTimeEnabled', 'closeTimeArray', 'validClosedTime');
                break;
        }
    }

    validateFacilityChargesHoldBookings(that, validateField, iconObj) {
        this.setLocalValuestoFacility(that, iconObj);
        switch (validateField) {
            case 'facility.holdBookingDays':
                if (!that.facility.isChargable) {
                    that.facility.holdBookingDays = '';
                }
                if (that.facility.isChargable) {
                    this.validateParaForNUll(that, 'validHoldBooking', 'facility', 'holdBookingDays');
                } else {
                    this.validate.validHoldBooking = '';
                }
                break;
            case 'facility.amount.value':
                if (!that.facility.isChargable || that.facility.isChargable && that.facility.amount.value <= '0') {
                    that.facility.amount.value = '';
                }
                if (that.facility.isChargable && that.facility.amount.value === '') {
                    this.validate.validAmount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                } else {
                    this.validate.validAmount = '';
                }
                break;
        }
    }

    validateFacilityReminderNotification(that, validateField, iconObj) {
        this.setLocalValuestoFacility(that, iconObj);
        let thatFacilityValidation = this;
        switch (validateField) {
            case 'facility.reminder.value':
                setTimeout(function () {
                    if (that.facility.reminder.value === '') {
                        thatFacilityValidation.validate.validReminder = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        thatFacilityValidation.validate.validReminder = '';
                    }
                }, 0);
                break;
            case 'facility.notificationAcceptanceHour':
                setTimeout(function () {
                    if (that.facility.notificationAcceptanceHour === '') {
                        thatFacilityValidation.validate.validNotificationAcceptanceHour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        thatFacilityValidation.validate.validNotificationAcceptanceHour = '';
                    }
                }, 0);
                break;
        }
    }
    validateFacilityMaxAttendees(that, validateField, iconObj) {
        this.setLocalValuestoFacility(that, iconObj);
        switch (validateField) {
            case 'facility.maxNumberOfPeopleWeekday':
                if (that.facility.maxNumberOfPeopleWeekday <= '0' && that.facility.isAttendeeCountRequired) {
                    that.facility.maxNumberOfPeopleWeekday = '';
                } else {
                    if (that.facility.isAttendeeCountRequired) {
                        this.validateParaForNUll(that, 'validMaxNumberOfPeopleWeekday', 'facility', 'maxNumberOfPeopleWeekday');
                    } else {
                        this.validate.validMaxNumberOfPeopleWeekday = '';
                        that.facility.maxNumberOfPeopleWeekday = '';
                    }
                }
                break;
            case 'facility.maxNumberOfPeopleWeekend':
                if (that.facility.maxNumberOfPeopleWeekend <= '0' && that.facility.isAttendeeCountRequired) {
                    that.facility.maxNumberOfPeopleWeekend = '';
                } else {
                    if (that.facility.isAttendeeCountRequired) {
                        this.validateParaForNUll(that, 'validMaxNumberOfPeopleWeekend', 'facility', 'maxNumberOfPeopleWeekend');
                    } else {
                        this.validate.validMaxNumberOfPeopleWeekend = '';
                        that.facility.maxNumberOfPeopleWeekend = '';
                    }
                }
                break;
        }
    }

    validateFacilityBookings(that, validateField, iconObj) {
        this.setLocalValuestoFacility(that, iconObj);
        switch (validateField) {
            case 'maxBookingHoursWeekday':
                if (that.facility.isMaxBookingPerMembership) {
                    this.validateParaForNUll(that, 'validMaxBookingHoursWeekday', 'facility', 'maxBookingHoursWeekday');
                } else {
                    this.validate.validMaxBookingHoursWeekday = '';
                    that.facility.maxBookingHoursWeekday = '';
                }
                break;
            case 'facility.maxBookingHoursWeekend':
                if (that.facility.isMaxBookingPerMembership) {
                    this.validateParaForNUll(that, 'validmaxBookingHoursWeekend', 'facility', 'maxBookingHoursWeekend');
                }
                else {
                    this.validate.validmaxBookingHoursWeekend = '';
                    that.facility.maxBookingHoursWeekend = '';
                }
                break;
            case 'facility.maxWeekdayBooking':
                if (that.facility.isMaxBookingPerPerson) {
                    this.validateParaForNUll(that, 'validMaxWeekdayBooking', 'facility', 'maxWeekdayBooking');
                } else {
                    this.validate.validMaxWeekdayBooking = '';
                    that.facility.maxWeekdayBooking = '';
                }
                break;
            case 'facility.maxWeekendBooking':
                if (that.facility.isMaxBookingPerPerson) {
                    this.validateParaForNUll(that, 'validMaxWeekendBooking', 'facility', 'maxWeekendBooking');
                } else {
                    this.validate.validMaxWeekendBooking = '';
                    that.facility.maxWeekendBooking = '';
                }
                break;
        }
    }
    validateFacilityObj(that) {
        let flag;
        this.setLocalValuestoFacility(that, '');
        this.changedRuleForAminity(that);
        flag = that.facilityService.validateFacilityObject(that.facility, this.validate, that.unitNames, that.closeTimeArray, that.peekTimingsArray, that.functionHallFlag);
        return flag
    }

    /**
    * validate facility
    *
    * @param  validate field or facility object
    *
    * @response SUCCESS or FAILED
    */

    /**
    * setTimeout function is apply On drop down menu fields for validation
    *
    * @param  validate field or facility object
    *
    * @response SUCCESS or FAILED
    */


    validateFacility(that, validateField, iconObj) {
        this.setLocalValuestoFacility(that, iconObj);
        let thatFacilityValidation = this;
        switch (validateField) {
            case 'facility.category':
              // this.validateNamePara(that, 'validCategory', 'facility', 'category');
                break;
            case 'facility.name':
                this.validateNamePara(that, 'validName', 'facility', 'name');
                break;
            case 'unitNames':
                this.validateNamePara(that, 'validUnitNames', '', 'unitNames');
                break;
            case 'facility.noOfUnits':
                this.validateParaForNUll(that, 'validNoOfUnits', 'facility', 'noOfUnits');
                break;
            case 'icon':
                setTimeout(function () {
                    if (iconObj.name === '') {
                        thatFacilityValidation.validate.validIcon = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        thatFacilityValidation.validate.validIcon = '';
                    }
                }, 0);
                break;
            case 'facility.slotDuration':
                if (that.functionHallFlag) {
                    this.validate.validSlotDuration = '';
                } else {
                    this.validateParaForNUll(that, 'validSlotDuration', 'facility', 'slotDuration');
                }
                break;
            case 'facility.peakUnitsCount':
                if (that.functionHallFlag) {
                    this.validate.validPeekSlotDuraion = '';
                    return;
                } else if (that.facility.isPeakTimeEnabled) {
                    this.validateParaForNUll(that, 'validPeekSlotDuraion', 'facility', 'peakUnitsCount');
                }
                else {
                    this.validate.validPeekSlotDuraion = '';
                }
                break;
            case 'facility.waitlistCount':
                if (that.facility.waitlistCount <= '0' && that.facility.isWaitlistEnabled) {
                    that.facility.waitlistCount = '';
                } else if (that.facility.isWaitlistEnabled) {
                    this.validateParaForNUll(that, 'validWaitlistCount', 'facility', 'waitlistCount');
                } else {
                    this.validate.validWaitlistCount = '';
                }
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/facility/facility-rule/facility-validation.ts